import { Logo, openRegistration } from "./shared";

export const Nav = () => {
  return (
    <header
      data-testid="site-nav"
      className="sticky top-0 z-50 bg-white/85 backdrop-blur-xl border-b border-slate-200/80"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-4">
        <a href="/" data-testid="nav-logo" aria-label="Protego AI home">
          <Logo />
        </a>
        <div className="hidden lg:flex items-center gap-4">
          <span
            data-testid="nav-session-marker"
            className="font-mono text-[11px] font-medium tracking-wide text-slate-600 border border-slate-200 rounded-full px-3.5 py-1.5"
          >
            10+ Years · <span className="text-indigo-600 font-semibold">2,000+ Amazon Accounts Reinstated</span>
          </span>
        </div>
        <button
          data-testid="nav-reserve-seat-btn"
          onClick={openRegistration}
          className="shrink-0 bg-indigo-500 hover:bg-indigo-600 text-white font-bold text-sm rounded-full px-6 py-2.5 transition-colors duration-200"
        >
          Reserve Seat
        </button>
      </div>
    </header>
  );
};
